import React, { useRef, useEffect, useCallback } from 'react';

import { MatchingColorsMap, TEXTRACT_MATCH_STATUSES } from '@/components/TwoWayMatch/matching';

export const TwoWayMatchTableCells = (props) => {
  const { width, height, rowMatchStatuses, tableCells, page } = props;
  const canvasRef = useRef();
  const canvasId = `textract-${page}`;

  const cellStyle = useCallback((rowMatchStatus, tableCell, colorsMap) => {
    switch (true) {
      case parseInt(tableCell.row, 10) === 1:
        return colorsMap[TEXTRACT_MATCH_STATUSES.HEADER];
      case rowMatchStatus === 'match':
        return colorsMap[TEXTRACT_MATCH_STATUSES.MATCH];
      case rowMatchStatus === 'partial_match':
        return colorsMap[TEXTRACT_MATCH_STATUSES.PARTIAL_MATCH];
      default:
        return colorsMap[TEXTRACT_MATCH_STATUSES.DEFAULT];
    }
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    // Setting the size clears the canvas, so every change below redraws the whole table.
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d');
    // Polygon points are fractions of the canvas width and height.
    tableCells.forEach((tableCell) => {
      // @to-do add default to getter
      const rowMatchStatus = rowMatchStatuses.get(parseInt(tableCell.row, 10));
      // refactor based on rowMatchStatus. By default all rows are red, match status rows are green
      const { border, fill } = cellStyle(rowMatchStatus, tableCell, MatchingColorsMap);

      context.strokeStyle = border;
      context.fillStyle = fill;
      context.lineWidth = 1;
      const points = tableCell.Geometry.Polygon;
      context.beginPath();
      context.moveTo(canvas.width * points[0].X, canvas.height * points[0].Y);
      points.slice(1).forEach((point) => context.lineTo(canvas.width * point.X, canvas.height * point.Y));
      context.closePath();
      context.stroke();
      context.fill();
    });
  }, [tableCells, height, width, rowMatchStatuses, cellStyle]);

  return <canvas id={canvasId} ref={canvasRef} style={{ position: 'absolute', left: 0, top: 0 }} />;
};
